import React from 'react';

const StructuredData = ({ type, data }) => {
  let structuredData = {};

  switch (type) {
    case 'organization':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": data.name_ar || "جامعة ابن النفيس للعلوم الطبية",
        "alternateName": data.name_en || "Ibn Al-Nafis University for Medical Sciences",
        "url": "https://uni-content-fixer.preview.emergentagent.com",
        "logo": data.logo,
        "description": data.description_ar,
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "YE",
          "addressLocality": "Sana'a",
          "addressRegion": "Sana'a",
          "streetAddress": data.address_ar
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": data.phone,
          "email": data.email,
          "contactType": "Admissions"
        },
        "sameAs": [
          data.facebook,
          data.twitter,
          data.instagram,
          data.youtube,
          data.linkedin
        ].filter(Boolean)
      };
      break;

    case 'course':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Course",
        "name": data.title_ar,
        "description": data.description_ar,
        "provider": {
          "@type": "EducationalOrganization",
          "name": "جامعة ابن النفيس للعلوم الطبية",
          "url": "https://uni-content-fixer.preview.emergentagent.com"
        },
        "educationalCredentialAwarded": data.degree,
        "timeRequired": data.duration,
        "image": data.image,
        "url": `https://uni-content-fixer.preview.emergentagent.com/programs/${data.id}`
      };
      break;

    case 'newsarticle':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "headline": data.title_ar,
        "alternativeHeadline": data.title_en,
        "description": data.excerpt_ar || data.content_ar?.substring(0, 150),
        "image": data.image,
        "datePublished": data.published_date,
        "dateModified": data.updated_at,
        "author": {
          "@type": "Organization",
          "name": "جامعة ابن النفيس للعلوم الطبية"
        },
        "publisher": {
          "@type": "Organization",
          "name": "جامعة ابن النفيس للعلوم الطبية",
          "logo": {
            "@type": "ImageObject",
            "url": data.publisher_logo
          }
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": `https://uni-content-fixer.preview.emergentagent.com/news/${data.id}`
        }
      };
      break;

    case 'breadcrumb':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": data.items.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };
      break;

    default:
      return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default StructuredData;
